import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import Markdown from "markdown-to-jsx";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import "../LaunchComponent/LaunchDataDisplay.css";
import "./ReminderDataDisplay.css";
import ReminderSubmissionPop from "./ReminderSubmissionPop";
const ReminderDataDisplay = ({
  mailerParent,
  mailerChild,
  setIsReminderGenerationClicked,
  categoryNameReminder,
  handleReset,
  setIsReminderNavigatedToForm,
  setIsReminderMailGenerated,
  programNameReminder
}) => {
  const [open, setOpen] = useState(false);
  const isSubmitted = useSelector(state => state.model.isSubmitted);
  const isReminderLoaded = useSelector(state => state.reminder.isReminderLoaded);
  const reminderMail = useSelector(state => state.reminder.reminderMail);
  return <>
   <div className="data-display-new">
    <div className="result-container">
     <div className="result-wrap">
      <div className="result-content">
       {!isReminderLoaded && <Box display="flex" flexDirection="column" alignItems="center" sx={{
              height: "100%",
              justifyContent: "center"
            }}>
         <CircularProgress />
         <Typography variant="h6" marginTop={2}>
          Generating...
         </Typography>
        </Box>}
       {isReminderLoaded && reminderMail != "" && <Stack spacing={2} sx={{
              padding: "0px",
              background: "white"
            }}>
         <style>
          {`
                    .highlight {
                        font-weight: bold;
                        color: black;
                    }
                `}
         </style>

         <div className="migrated-style-reminderdatadisplay-4331bd-1">
          <Markdown>{reminderMail}</Markdown>
         </div>
        </Stack>}
      </div>
      <div className="result-btn-container">
       <div className="result-left">
        {isReminderLoaded && <Button variant="outlined" sx={{
                marginRight: "10px"
              }} disabled={isSubmitted ? true : false} onClick={() => {
                setOpen(true);
              }}>
          Submit For Approval
         </Button>}
       </div>
       <div className="result-right">
        <img src={process.env.PUBLIC_URL + "/Images/Dislikeicon.png"} />
        <img src={process.env.PUBLIC_URL + "/Images/Likeicon.png"} />
       </div>
      </div>
     </div>
     <div className="return-wrap">
      <p onClick={() => {
            setIsReminderGenerationClicked(false);
            // dispatch(handleTeaserLoading());
            setIsReminderNavigatedToForm(true);
            setIsReminderMailGenerated(null);
          }}>
       {"<"} Back
      </p>
     </div>
     <ReminderSubmissionPop open={open} setOpen={setOpen} mailerParent={mailerParent} mailerChild={mailerChild} modalResponse={reminderMail} categoryNameReminder={categoryNameReminder} handleReset={handleReset} programNameReminder={programNameReminder} />
    </div>
   </div>
  </>;
};
export default ReminderDataDisplay;
